import MetricBase from "models/metrics/MetricBase";
import i18n from "i18next";
import PercentUnit from "models/metrics/unit/PercentUnit";
import PerformanceGroup from "../../../../groups/PerformanceGroup";

class MetricImprShare extends MetricBase {
    constructor() {
        super({
            field: "metric_impr_share",
            defaultVisibility: false,
            unit: new PercentUnit(),
            chartName: i18n.t("metrics.tripadvisor.impr_share.chartName"),
            serieLabel: i18n.t("metrics.tripadvisor.impr_share.serieLabel"),
            tooltip: i18n.t("metrics.tripadvisor.impr_share.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricImprShare;
